<template>
  <div class="contant-wrap">
    <div class="header">
      <h4 class="common-title">诊所设置</h4>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}"
      style="width: 100%; margin-top: 20px;">
      <el-table-column
        prop=""
        label="功能设置"
        width="380px">
        <template slot-scope="scope">
          <span class="title">是否允许0库存售药：</span>
          <el-radio-group v-model="sellDrugWithoutInventory">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group> 
        </template>
      </el-table-column>
      <el-table-column
        prop="Desc"
        label="功能说明"
        width="">
        <template slot-scope="scope">
        {{scope.row.Desc}}<span class="red">注意：选择“否”时，请确保药品库存数量的准确，以免影响开药售药。</span>
        </template>
      </el-table-column>
    </el-table>
    <footer-control>
      <template slot="right">
        <el-button type="primary" class="button" @click="changeSel()">保存</el-button>
      </template>
    </footer-control>
  </div>
</template>

<script>
import FooterControl from '@/components/FooterControl.vue';

export default {
  components: { FooterControl },
  data() {
    return {
      sellDrugWithoutInventory: 1,
      tableData: [
        {
          Desc:'是（如库存不足时，确认收费后系统会自动生成外购单，补库存）;否（当库存不足时，不支持0库存售药）',
        }
      ]
    }
  },
  mounted() {
    this.getHospitalConfig();
  },
  methods: {
    // 获取诊所基础功能配置
    getHospitalConfig() {
      this.$api.clinicManagement.getHospitalConfig({
        configType: 10,
      }).then((res) => {
        this.sellDrugWithoutInventory = res.sellDrugWithoutInventory;
      });
    },
    changeSel() {
      this.$api.clinicManagement.saveHospitalConfig({
        configType: 10,
        sellDrugWithoutInventory: this.sellDrugWithoutInventory,
      }).then(res => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.contant-wrap {
  box-sizing: border-box;
  min-height: 100%;
}
.header {
  display: flex;
  justify-content: space-between;
  span {
    color: #999999;
    margin-left: 10px;
  }
  .el-icon-info {
    color: #88BEFD;
  }
  span {
    color: #999999;
  }
}
.red {
  color: #FF0000;
}
</style>
